import styled from "styled-components";
const Table = styled.table`
  border-bottom: 1px solid #eee;
  border-left: 1px solid #eee;
  border-top: 1px solid #eee;
  background-color: white;
`;
const Thead = styled.thead`
  > tr > th {
    text-align: center;
    padding: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border-right: 1px solid #eee;
    border-bottom: 2px solid #eee;
    font-size: 10pt;
  }
`;
const TableContainer = styled.div`
  margin-top: 20px;
`;
const HeaderText = styled.h4`
  margin-top: 0px;
  margin-bottom: 10px;
`;

const SubTitle = styled.span`
  color: #bdbdbd;
  font-size: 10pt;
  text-transform: uppercase;
  margin-left: 10px;
`;

export { Table, Thead, TableContainer, HeaderText, SubTitle };
